<template>
    <div class="vx-row mt-4">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="w-full text-center">
                    <div class="component">
                        <span class="title-hashtag font-bold">Media Wall</span>
                    </div>
                    <div class="component">
                        <span class="font-time-hashtag-title">{{ $t('hashtag.from') }} {{ from }} - {{ to }}</span>
                    </div>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col md:w-1/3 w-full mb-4" v-for="(card, indexCard) in listDataHashtag" :key="indexCard">
                    <div class="component w-full border">
                        <div class="w-full" style="height:200px" v-if="card.img">
                            <img @error="imgError" :src="card.img" alt="" height="200" class="w-full border-image">
                        </div>
                        <div class="vx-row mt-4 ml-0 mr-0">
                            <div class="ml-3 md:w-1/12">
                                <img src="@/assets/images/portrait/small/user-avatar.png" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
                            </div>
                            <div class="leading-tight sm:block max-content md:w-6/12 ml-3">
                                <div class="component inline-flex mb-1" style="width:225px">
                                    <p class="font-semibold m-auto ml-2 user-name-hashtag">{{ card.sourceName }}</p>
                                    <span class="m-auto ml-2" style="min-width: 65px">{{ $t('hashtag.post') }}</span>
                                </div>
                                <p class="font-time-hashtag ml-2"> {{ card.publishDate }}</p>
                            </div>
                            <div class="text-right md:w-3/12 cursor-pointer" @click="saveBookmark(card)">
                                <div class="component">
                                    <vx-tooltip
                                        class="float-right"
                                        color="warning"
                                        :text="card.isBookmark ? $t('articleDetail.unSavedChanges') : $t('articleDetail.save')">
                                        <feather-icon icon="BookmarkIcon" class="bookmark-custom cursor-pointer" style="color:rgba(var(--vs-warning),1)" v-if="card.isBookmark"></feather-icon>
                                        <feather-icon icon="BookmarkIcon" class="bookmark-custom cursor-pointer" v-else></feather-icon>
                                    </vx-tooltip>
                                </div>
                            </div>
                        </div>
                        <div class="vx-row mt-2 ml-0 mr-0">
                            <div class="vx-col w-full text-content-hashtag">
                                <p v-if="!card.showMore" v-html="card.displayFullContent.slice(0, 200) + '...'" class="font-regular" style="color: #24243A"></p>
                                <p v-if="card.showMore" v-html="card.displayFullContent" class="font-regular" style="color: #24243A"></p>
                            </div>
                            <div class="limited-text mt-2 text-primary pr-0 ml-4 mr-4" style="width:20%" v-for="(hashtag,  indexHashtag) in (card.showMore ? card.hastags : card.hastags.slice(0, 3))" :key="indexHashtag">
                                <span class="mr-2">#{{ hashtag }}</span>
                            </div>
                            <div class="vx-col w-full mt-2 text-right">
                                <span class="ml-auto text-primary cursor-pointer" style="font-size:12px" @click="showMore(card)">{{ card.showMore ? $t('title.readLess') : $t('title.readMore')}}</span>
                            </div>
                            <div class="vx-col mt-2 w-full card-link ml-4 mr-4 flex cursor-pointer" @click="openURLHashtag(card)">
                                <div class="md:w-3/12 w-full mt-2">
                                    <feather-icon icon="LinkIcon" style="width:1.2rem"></feather-icon>
                                </div>
                                <div class="md:w-9/12 w-full text-title-hashtag">
                                    <div class="w-full">
                                        <span>{{ card.title }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row mt-4 ml-0 mr-0">
                            <div class="vx-col w-full pr-4 ">
                                <div class="component w-full" style="border-top: 1px solid #EBEBEB">
                                    <div class="vx-row ml-0">
                                        <div class="mr-auto mt-2 mb-2 ">
                                            <feather-icon icon="SmileIcon" class="shade-custom"></feather-icon>
                                            <span class="ml-3 text-value">{{ eArabic(card.like) }}</span>
                                        </div>
                                        <div class="ml-auto mt-2 mb-2">
                                            <span class="text-value">{{ eArabic(card.comment) }}</span>
                                            <span class="ml-1 font-text-card">{{ $t('hashtag.comment') }}</span>
                                        </div>
                                        <div class="ml-2 mt-2 mb-2 mr-4">
                                            <span class="text-value">{{ eArabic(card.share) }}</span>
                                            <span class="ml-1 font-text-card">{{ $t('hashtag.share') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col w-full mt-4 text-center">
                    <vs-button style="border-radius: 20px" @click="addRecord">{{ $t('hashtag.seeMore') }}</vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import NoImage from '@/assets/images/logo/instagram.jpeg';
export default {
    components: {

    },
    props: {
        hashTagName: {
            type: String,
            default: null
        },
        refreshData: {default: 0}
    },
    watch: {
        refreshData: function (newVal, oldVal) {
            this.initScreen();
        }
    },
    data(){
        return {
            checkImg:true,
            listDataHashtag: [],
            listHashtag: ['#24h.com','#Iphone', '#promax', '#fakasdasd', '#213123211'],
            dateRange: {
                endDate: new Date(),
                startDate: (() => {
                let date = new Date();
                date.setDate(date.getDate() - 29);
                date.setHours(0, 0, 0);
                return date;
                })()
            },
            from: null,
            to: null,
            numberOfDisplayPosts: 12,
        }
    },
    methods: {
        showMore: function(item){
            item.showMore = !item.showMore;
        },
        imgError(image){
            image.target.src = NoImage;
        },
        openURLHashtag: function(card){
            window.open(card.url, '_blank');
        },
        getDataHashtag: function(condition){
            this.$vs.loading();
            this.$processor.post('/user-data/find-by-condition-hashtag', condition).then((res) => {
                this.listDataHashtag = res.data.content.map(userData => {
                    if (userData.specialFields){
                        if (userData.beanType == 116) userData.like = userData.specialFields.loveCount;
                        else userData.like = userData.specialFields.likeCount;
                        userData.comment = userData.specialFields.commentCount ? userData.specialFields.commentCount : 0;
                        userData.share = userData.specialFields.shareCount ? userData.specialFields.shareCount : 0;

                    }
                    if(userData.fullContents && userData.fullContents.length > 0){
                        userData.displayFullContent = userData.fullContents.filter(item => item.type == "text").map((elements) => {
                        if(elements.content){
                            return elements.content.replaceAll('#', '').trim();
                        }
                        }).join("\n");
                    }
                    if (userData.hastags && userData.hastags.length > 0){
                        this.highlightHashtagInContent(userData.hastags, userData);
                    }
                    if (userData.publishDate) {
                        userData.publishDate = moment(userData.publishDate).format("DD/MM mm:hh")
                    }
                    if (userData.attachmentUrls && userData.attachmentUrls.length > 0){
                        userData.img = userData.attachmentUrls[0].url;
                    }
                    if (userData.title && userData.title.length  > 60) {
                        userData.title = userData.title.slice(0, 60) + "...";
                    }
                    userData.showMore = false;
                    return userData;
                });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        highlightHashtagInContent: function(hashtags,item){
            for (let hashtag of hashtags) {
                let hashtagIndex = item.displayFullContent.toLowerCase().indexOf(hashtag.toLowerCase())
                if (hashtagIndex >= 0 ) {
                item.displayFullContent = item.displayFullContent.slice(item.displayFullContent.slice(0, hashtagIndex).lastIndexOf(".") + 1);
                item.displayFullContent = item.displayFullContent.replace(new RegExp(hashtag, "ig"), `<b class="text-highlight">#${hashtag}</b>`);
                }
                // break;
            }
            if (!item.displayFullContent) {
                item.displayFullContent = item.displayFullContent.slice(0, item.displayFullContent.indexOf("."));
            }
        },
        addRecord: function(){
            let addPostNumber = 12;
            this.numberOfDisplayPosts = this.numberOfDisplayPosts + addPostNumber;
            this.initScreen();
        },
        initScreen(){
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
            let fromDate = this.dateRange.startDate;
            let toDate = this.dateRange.endDate;
            let conditions = {
                hashtagName: this.hashTagName,
                from: fromDate,
                to: toDate,
                beanTypeSocial: [],
                pageNumber: 0,
                pageSize: this.numberOfDisplayPosts
            };
            this.getDataHashtag(conditions);
        },
        saveBookmark: function(item){
            this.$vs.loading();
            const payload ={
                id: item.id
            }
            this.$processor.post('/user-data/update-bookmark',payload).then((res) =>{
                this.initScreen();
                this.$vs.loading.close();
                this.$vs.notify({
                text: res.data.isBookmark ? this.$t('articleBookmark.textSave') : this.$t('articleBookmark.rejectPost'),
                iconPack: 'feather',
                icon: 'icon-alert',
                color: 'primary'
                })
            }).catch(()=>{
                this.$vs.loading.close();
                this.$vs.notify({
                    text: this.$t('articleBookmark.seveNotDone'),
                    iconPack: 'feather',
                    icon: 'icon-alert',
                    color: 'danger'
                })
            })
        },
        eArabic: function(x) {
            return x ? x.toLocaleString("de-DE") : 0;
        },
    },
    created(){
        this.from = moment(this.dateRange.startDate).format('DD/MM/YYYY');
        this.to = moment(this.dateRange.endDate).format('DD/MM/YYYY');
        this.initScreen();
    }
}
</script>

<style scoped>
.border {
    border: 1px solid #ebe4e4;
    border-radius: 6px;
}
.border-image {
    border-radius: 5px 5px  0px  0px;
    object-position: center;
    object-fit: cover;
}
.limited-text{
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bookmark-custom { 
    width: 1.3rem; 
    color: #BABFC7;
}
.shade-custom {
    width: 1.3rem;
    vertical-align: bottom;
}
.text-value {
    font-weight: bold;
    font-size: 12px;
}
.font-text-card {
    font-size: 12px;
}
.user-name-hashtag {
    font-size: 16px;
    max-width: 150px;
}
.font-time-hashtag {
    font-size: 14px;
    color: #9E9E9E;
}
.title-hashtag {
    font-size: 18px;
}
.font-time-hashtag-title {
    font-size: 16px;
    color: #9E9E9E;
}
.text-content-hashtag{
  /* height: 34px; */
  word-wrap: break-word;
}
.card-link {
    background-color: #F6F6F6;
    padding: 8px 24px;
    border-radius: 5px;
}
.text-title-hashtag {
    line-height: 1.5em;
    height: 3em;       /* height is 2x line-height, so two lines will display */
    overflow: hidden;
}
::v-deep b {
    color: rgba(39, 125, 246);
}
</style>